module.exports = "build/assets/whySiftBg.5dee805c.png";